module.exports = __webpack_public_path__ + "img/avatar-4.3524784f.png";